/* STOCKKA Mega Menu 5 */
(function(){
  function init(){
    document.querySelectorAll('[data-stk-mega]').forEach(function(nav){
      if(nav.dataset.stkInit) return; nav.dataset.stkInit='1';
      var wrap = nav.closest('.vertical-menu'); if(nav.parentElement) nav.parentElement.classList.add('stk-host');
      var cats = nav.querySelectorAll('[data-stk-cat]');
      var panels = nav.querySelectorAll('[data-stk-panel]');
      var t;
      function activate(i){
        cats.forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-stk-cat')===i); });
        panels.forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-stk-panel')===i); });
      }
      cats.forEach(function(c){
        var i=c.getAttribute('data-stk-cat');
        c.addEventListener('mouseenter',function(){ clearTimeout(t); t=setTimeout(function(){activate(i)},60); });
        c.addEventListener('focusin',function(){ activate(i); });
      });
      var pill = nav.closest('.header-single-line__content');
      function place(){ if(!pill || window.innerWidth<=1024) return; var r=pill.getBoundingClientRect();
        nav.classList.add('is-placed'); nav.style.setProperty('--stk-top','0px'); nav.style.setProperty('--stk-left','0px'); nav.style.setProperty('--stk-w',r.width+'px');
        var pt=nav.style.transition, prev=nav.style.transform; nav.style.transition='none'; nav.style.transform='none'; var o=nav.getBoundingClientRect(); nav.style.transform=prev; void nav.offsetWidth; nav.style.transition=pt;
        nav.style.setProperty('--stk-top',(r.bottom+10-o.top)+'px'); nav.style.setProperty('--stk-left',(r.left-o.left)+'px'); }
      place(); window.addEventListener('resize',place); window.addEventListener('scroll',place,{passive:true});
      if(wrap){ wrap.addEventListener('mouseenter',place); }
      if(wrap){
        var btn = wrap.querySelector('.categories-title__button');
        if(btn){
          btn.setAttribute('role','button'); btn.setAttribute('tabindex','0'); btn.setAttribute('aria-expanded','false');
          var toggle=function(e){ e.preventDefault(); var o=wrap.classList.toggle('stk-open'); btn.setAttribute('aria-expanded', o?'true':'false'); };
          btn.addEventListener('click',toggle);
          btn.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' ') toggle(e); });
        }
        document.addEventListener('click',function(e){ if(!wrap.contains(e.target)){ wrap.classList.remove('stk-open'); if(btn) btn.setAttribute('aria-expanded','false'); } });
        document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ wrap.classList.remove('stk-open'); if(btn) btn.setAttribute('aria-expanded','false'); } });
      }
    });
  }
  function initMobile(){
    var m=document.querySelector('[data-stk-mmob]'); if(!m) return;
    var host=document.querySelector('#navigation-mobile .halo-sidebar-wrapper') || document.querySelector('#navigation-mobile');
    if(!host) return;
    if(!m.dataset.stkMoved){
      var nav=host.querySelector('[data-navigation-mobile]');
      host.insertBefore(m, nav || host.firstChild); m.hidden=false; m.dataset.stkMoved='1';
      host.classList.add('stk-has-mmob');
      var l1=m.querySelector('[data-stk-nv-l1]');
      var show=function(id){
        m.querySelectorAll('[data-stk-nv-panel]').forEach(function(p){ p.hidden=(p.getAttribute('data-stk-nv-panel')!==id); });
        m.querySelectorAll('[data-stk-nv-open]').forEach(function(b){ b.setAttribute('aria-expanded', b.getAttribute('data-stk-nv-open')===id?'true':'false'); });
        if(l1) l1.hidden=!!id; host.scrollTop=0;
        if(id){ var bk=m.querySelector('[data-stk-nv-panel="'+id+'"] [data-stk-nv-back]'); if(bk) bk.focus({preventScroll:true}); }
      };
      m.addEventListener('click',function(e){
        var o=e.target.closest('[data-stk-nv-open]'); if(o){ show(o.getAttribute('data-stk-nv-open')); return; }
        if(e.target.closest('[data-stk-nv-back]')) show('');
      });
      m.stkNvReset=function(){ show(''); };
    }
    // hide the old "categories" drill-down (it shows the same category-menu)
    var handles=[].map.call(m.querySelectorAll('[data-stk-h]'),function(a){ var h=(a.getAttribute('href')||'').split('/collections/')[1]; return h?h.split(/[?#/]/)[0]:null; }).filter(Boolean);
    host.querySelectorAll('[data-navigation-mobile] .menu-lv-1').forEach(function(li){
      var hit=[].some.call(li.querySelectorAll('.menu-lv-2 > a[href]'),function(a){ var h=a.getAttribute('href')||''; return handles.some(function(x){ return h.indexOf('/collections/'+x)>-1 || h.indexOf('collection='+x)>-1; }); });
      if(hit) li.classList.add('stk-mmob-hide');
    });
  }
  function boot(){ init(); initMobile(); setTimeout(initMobile,1500); document.addEventListener('click',function(e){ if(e.target.closest('[data-mobile-menu]')){ setTimeout(initMobile,50); var mm=document.querySelector('[data-stk-mmob]'); if(mm && mm.stkNvReset) mm.stkNvReset(); } }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',init);
})();
